<div class="customer-list">
    <div class="customer-toolbar">
        <app-search-bar
                        [placeholder]="'Search Customers'"
                        (search)="searchTerm = $event; searchCustomers()">
        </app-search-bar>
        <button class="add-customer-button" type="button" (click)="createCustomer()">
            <mat-icon>person_add</mat-icon>
            <span>New Customer</span>
        </button>
    </div>

    <!-- Customer Cards -->
    <mat-card *ngFor="let customer of filteredCustomers"
              class="customer-card"
              [class.selected]="isSelected(customer.id)"
              (click)="openCustomerDetails($event, customer)">
        <div class="card-content">
            <div class="avatar" (click)="openCustomerDetails($event, customer)">
                <img *ngIf="customer.image" [src]="'data:' + (customer.imageMimeType || 'image/jpeg') + ';base64,' + customer.image" alt="Avatar" />
                <div *ngIf="!customer.image" class="initials">
                    {{ customer.name[0] | uppercase }}
                </div>
            </div>


            <div class="info">
                <div class="name">{{ customer.name }}</div>
                <div *ngIf="customer.categories?.length" class="tag">
                    {{ customer.categories[0] }}
                </div>
                <div class="phone">{{ customer.phone }}</div>
                <div *ngIf="customer.pendingSync || customer.photoSyncPending || (customer.pendingRouteSegmentIds?.length || 0) > 0" class="sync-badge">
                    {{ customer.pendingSync ? 'Pending Sync' : (customer.photoSyncPending ? 'Photo Pending' : 'Route Pending') }}
                </div>
                <div *ngIf="(customer.outstandingBalance || 0) > 0" class="customer-balance">
                    Balance : {{ customer.outstandingBalance | number:'1.2-2' }}
                </div>
            </div>

            <div class="right-section">
                <div *ngIf="customer.priceList" class="address">
                    {{ customer.priceList }}
                </div>
                <div *ngIf="customer.route" class="address">
                    {{ customer.route }}
                </div>
            </div>
        </div>
    </mat-card>
</div>
